import { AEntity } from "../a-entity";
import { Right } from "./right";

export class AccessRight extends AEntity {
    accessGroupId: number;
    rightId: number;
}
